import api from './api';

export const switchToUser = (userId) =>
  api.post(`/admin/switch-user/${userId}`, {});
